import { useState } from 'react'
import { Input, Select, Textarea } from '../../components/forms'
import Button from '../../components/ui/Button'

function ClientForm({
  initialData,
  businesses = [],
  onSubmit,
  onCancel,
  loading = false,
}) {
  const [formData, setFormData] = useState({
    business_id: initialData?.business_id || '',
    name: initialData?.name || '',
    email: initialData?.email || '',
    company: initialData?.company || '',
    phone: initialData?.phone || '',
    address: initialData?.address || '',
    notes: initialData?.notes || '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  const businessOptions = businesses.map(b => ({
    value: b.id,
    label: `${b.emoji} ${b.name}`,
  }))

  return (
    <form onSubmit={handleSubmit}>
      <Select
        label="Business"
        name="business_id"
        value={formData.business_id}
        onChange={handleChange}
        options={businessOptions}
        placeholder="Select business..."
        required
      />

      <div className="grid grid-2">
        <Input
          label="Contact Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="John Doe"
          required
        />
        <Input
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="john@company.com"
          required
        />
      </div>

      <div className="grid grid-2">
        <Input
          label="Company"
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="Acme Corp"
        />
        <Input
          label="Phone"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          placeholder="+1 555-0123"
        />
      </div>

      <Textarea
        label="Address"
        name="address"
        value={formData.address}
        onChange={handleChange}
        placeholder="123 Main St&#10;City, State 12345"
        rows={3}
      />

      <Textarea
        label="Notes"
        name="notes"
        value={formData.notes}
        onChange={handleChange}
        placeholder="Internal notes about this client..."
        rows={2}
      />

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          {initialData ? 'Update' : 'Add'} Client
        </Button>
      </div>
    </form>
  )
}

export default ClientForm
